module.exports = __webpack_public_path__ + "static/img/twjd-sdc4.5dbd14b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdc4.png
// module id = 834
// module chunks = 0